import { call, takeLatest } from 'redux-saga/effects';

import { fetchAllBooks, resource, getError } from 'modules/api';
import { GET_BOOKS } from 'modules/dashboard/store/constants';
import { getBooksPayload } from './utils';

export function* onGetBooks({ payload: meta }) {
  try {
    const request = resource(GET_BOOKS, fetchAllBooks, getBooksPayload);
    const payload = yield call(request, meta);

    return payload;
  } catch (error) {
    const payload = getError(error);
    // eslint-disable-next-line no-console
    console.error(payload);
    return payload;
  }
}

export function* watchGetBooks() {
  yield takeLatest(GET_BOOKS, onGetBooks);
}
